<div class="board-column">

  <div class="column-header">
    <div class="column-title">
      Your Quotes
    </div>
  </div>


  <ng-container *ngIf="loadingSpinner">
    <lib-progress-spinner></lib-progress-spinner>
  </ng-container>

  <div class="tasks-container" *ngIf="!loadingSpinner">
    <div class="project-alert" *ngFor="let quoteGroup of quoteGroups">
      <div class="quote-title">
        {{quoteGroup.title}}
      </div>
      <div class="quotes">
        <app-installer-quote *ngFor="let quote of quoteGroup.quotes" [quote]="quote"
                             (click)="openQuote(quote)"></app-installer-quote>
      </div>

    </div>
  </div>
</div>
